<template>
<v-container fluid grid-list-lg>
  <v-jumbotron v-if="noAccess">
    <v-container fill-height>
      <v-layout align-center>
        <v-flex>
          <h3 class="display-3">Welcome to VSS!</h3>

          <span class="subheading">Unfortunately, you currently do not have access to any of the VSS services. Please consult with your administrator.</span>

          <v-divider class="my-3"></v-divider>
        </v-flex>
      </v-layout>
    </v-container>
  </v-jumbotron>


  <v-layout row wrap>

    <v-flex xs12 v-if="($can('view', 'pdfs') || $can('is', 'admin'))">
      <v-card color="primary">
        <v-card-title primary-title class="white--text">
          <div>
            <h3 class="headline mb-0">PDF Review</h3>
            <div>Review result PDF's</div>
          </div>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="navipage('Review')">Open</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-flex xs12 v-if="($can('view', 'analyzer') || $can('is', 'admin'))">
      <v-card color="primary">
        <v-card-title primary-title class="white--text">
          <div>
            <h3 class="headline mb-0">Job Manager</h3>
            <div>Manage job states, information, and more.</div>
          </div>
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="navipage('JobPage')">Open</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <!--<v-flex xs12 v-if="($can('view', 'analyzer') || $can('is', 'admin'))">-->
      <!--<v-card color="primary">-->
        <!--<v-card-title primary-title>-->
          <!--<div>-->
            <!--<h3 class="headline mb-0">analyzer</h3>-->
            <!--<div>Coming spring 2045</div>-->
          <!--</div>-->
        <!--</v-card-title>-->

        <!--<v-card-actions>-->
          <!--<v-spacer></v-spacer>-->
          <!--<v-btn @click="navipage('analyzer')">Open</v-btn>-->
        <!--</v-card-actions>-->
      <!--</v-card>-->
    <!--</v-flex>-->


  </v-layout>
</v-container>
</template>

<script>
export default {
  name: 'servers',
  data: function () {
    return {
      notSmallScreen: true,
      showSnackbar: false,
      position: 'center',
      duration: 4000,
      snackMessage: 'Test Here',
      uptime: '',
      cards: [{
        title: 'Pre-fab homes',
        src: '/doc-images/cards/house.jpg',
        flex: 6
      },
      {
        title: 'Favorite road trips',
        src: '/doc-images/cards/road.jpg',
        flex: 6
      },
      {
        title: 'Best airlines',
        src: '/doc-images/cards/plane.jpg',
        flex: 6
      }
      ]
      //  socket : io('ithinkijustpoopedmypantspanel.keinett.us')
    }
  },
  methods: {
    handleResize (event) {
      if (document.documentElement.clientWidth > 600) {
        this.notSmallScreen = true
      } else {
        this.notSmallScreen = false
      }
    },
    getTotalPlayers () {
      this.$http.get('/panel/totalplayers')
        .then(response => {

        })
        .catch(e => {
          this.showSnackbar = true
          this.snackMessage = 'Error getting totalPlayers!'
        })
    },
    logout () {
      localStorage.removeItem('jwtToken')
      this.$router.push({
        name: 'AppLogin'
      })
    },
    navipage (page) {
      this.$router.push({
        name: page
      })
    }
  },
  beforeMount () {

  },
  created: function () {

  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
    console.log('MOUNTED')

    // this.socket.on('SERVERINFO', (response) => {
    //     this.os = response.os;
    //
    //     var seconds = parseInt(this.os.uptime, 10);
    //
    //     var days = Math.floor(seconds / (3600 * 24));
    //     seconds -= days * 3600 * 24;
    //     var hrs = Math.floor(seconds / 3600);
    //     seconds -= hrs * 3600;
    //     var mnts = Math.floor(seconds / 60);
    //     seconds -= mnts * 60;
    //     this.uptime = days + "d " + hrs + "h " + mnts + "m " + seconds + "s";
    // });
    //
    // this.socket.on('PLAYERINFO', (response) => {
    //     this.totalPlayers = response.players.online;
    // });
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    noAccess: function () {
      return !(this.$ability.rules.length > 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.flex-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin: 10px;
}
.md-inlinecard {
    flex: 1 1;
    min-width: 200px;
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 10px;
}
.md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/pages/MainPage.vue